<main class="container" nz-row>
  <section class="w100" nz-col [nzMd]="24" [nzLg]="11">
    <div class="loginBlock">
      <img *ngIf="step > 0" src="assets/icons/backArrow.svg" alt="back arrow" (click)="backTologinField()"
           class="backArrow"/>
      <h4 [translate]="'HOME.LOGIN_PAGE.LOGIN_TITLE'">Вход в BCC Business</h4>

      <nz-tabset *ngIf="isAkKamalAvailable"
      [nzSize]="'large'"
      nzTabBarGutter="60"
      >
        <nz-tab
        [nzTitle]="'По номеру телефона'"
        >
        <div>
          <form nz-form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
            <h4 [translate]="'HOME.LOGIN_PAGE.LOGIN_BY_PHONE'">Вход в BCC Business</h4>
            <nz-form-item class="login-form__name" *ngIf="step === 0">
              <nz-form-label nzSpan="24" nzFor="phoneNumber" [innerHTML]="'HOME.LOGIN_PAGE.FORM.INPUT_PHONE' | translate">
                Номер телефона
              </nz-form-label>
              <nz-form-control [nzErrorTip]="'HOME.LOGIN_PAGE.FORM.ERROR_PHONE_REQUIRED' | translate">
                <input class="form-input" formControlName="phoneNumber" prefix="+7" mask=" (000) 000-00-00" nz-input
                  id="phoneNumber" placeholder="+7 (700) 000-00-00" autocomplete="off" />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="login-form__password" *ngIf="step === 1">
              <nz-form-label nzSpan="24" nzFor="userPass" [innerHTML]="'HOME.LOGIN_PAGE.FORM.INPUT_PASSWORD' | translate">
                Пароль
              </nz-form-label>
              <nz-form-control class="form-input" [nzErrorTip]="'HOME.LOGIN_PAGE.FORM.ERROR_PASSWORD_REQUIRED' | translate">
                <nz-input-group [nzSuffix]="visibilityTemplate">
                  <input formControlName="password" [attr.name]="'userPass' + step" [attr.id]="'userPass' + step" type="text"
                    [ngClass]="passwordVisible ? 'password-visible' : 'password-hidden'" nz-input />
                </nz-input-group>
                <ng-template #visibilityTemplate>
                  <img *ngIf="passwordVisible; else passwordHidden" src="assets/icons/Eye%20open/M.svg" alt=""
                    (click)="isPasswordVisible()">
                  <ng-template #passwordHidden>
                    <img src="assets/icons/Eye%20close/M.svg" alt="" (click)="isPasswordVisible()">
                  </ng-template>
                </ng-template>
              </nz-form-control>
            </nz-form-item>

            <p class="text-red" *ngIf="loginForm.hasError('invalid_credentials')"
               [translate]="'HOME.LOGIN_PAGE.FORM.ERROR_INVALID_CREDENTIALS'">
              Неправильный номер телефона или пароль
            </p>
            <div>
              <button *ngIf="step === 0" (click)="checkValidLogin($event)" class="login-form__login-btn" nz-button
                      nzType="primary" nzSize="large"
                      [disabled]="!checkValidNumber()"
                      type="submit">
                {{'HOME.LOGIN_PAGE.FORM.BTN_CONTINUE' | translate}}
              </button>
            </div>
            <div>
              <button *ngIf="step === 1" [nzLoading]="isLoading" class="login-form__login-btn" nz-button nzType="primary"
                      nzSize="large"
                      [disabled]="!checkFormValid()"
                      type="submit">
                {{'HOME.LOGIN_PAGE.FORM.BTN_LOGIN' | translate}}
              </button>
            </div>
            <app-faq *ngIf="step === 0">авывыф</app-faq>
            <app-safety-measures *ngIf="step === 0"></app-safety-measures>
            <p (click)="goToRecovery()" *ngIf="step === 1" class="login-form__forgot-password" [translate]="'HOME.LOGIN_PAGE.FORM.FORGOT_PASSWORD'">Не
              помните
              пароль?</p>
          </form>
          <!-- Шаг 2, выбор компании-->
          <div class="stepBlock" *ngIf="step === 2">
            <nz-form-item class="companySelector">
              <nz-form-label nzSpan="24">
                <h4 [translate]="'HOME.LOGIN_PAGE.FORM.SELECT_COMPANY'">Выберите компанию</h4>
              </nz-form-label>
              <nz-form-control>
                <nz-select [(ngModel)]="selectedCompany">
                  <nz-option *ngFor="let company of companyList" [nzLabel]="company.custname" [nzValue]="company.pcustomer">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <button [disabled]="!selectedCompany || companyList?.length === 1" class="login-form__login-btn" nz-button
                    nzType="primary" nzSize="large"
                    (click)="selectCompany()"
                    [nzLoading]="isLoading"
                    [translate]="'HOME.LOGIN_PAGE.FORM.SELECT'"
                    type="submit">
              Выбрать
            </button>
          </div>
          <!--Шаг 3, если нужна 2фа-->
          <div class="stepBlock " *ngIf="step === 3">
            <nz-form-item class="companySelector">
              <nz-form-label nzSpan="24">
                Введите код СМС
              </nz-form-label>
              <nz-form-control>
                <input nz-input [(ngModel)]="sms" (keydown.enter)="loginWith2fa()" maxlength="5"/>
              </nz-form-control>
            </nz-form-item>
            <button nz-button nzType="link" class="pt-0" (click)="selectCompany()"
                    [disabled]="smsTimer > 0"
                    [nzLoading]="isLoading">Отправить код повторно <span
              *ngIf="smsTimer > 0">, через {{this.smsTimer}}</span></button>
            <button [disabled]="!sms" class="login-form__login-btn" nz-button nzType="primary" nzSize="large"
                    (click)="loginWith2fa()"
                    [nzLoading]="isLoading"
                    type="submit">
              Подтвердить
            </button>
          </div>
        </div>
        </nz-tab>
        <nz-tab
        [nzTitle]="'По токену'"
        >
        <div>
          <div class="token__desc">
            Для входа установите программу
            <span class="enter-btn" (click)="btnEnterHandler()" >Ak Kamal e-Security Suite</span>
             и подключите Kaztoken
          </div>
          <button class="login-form__login-btn" (click)="btnEnterHandler()" nz-button
                    nzType="primary" nzSize="large"
                    [nzLoading]="isLoading"
                    [translate]="'HOME.LOGIN_PAGE.FORM.BTN_LOGIN'"
                    type="submit">
              Войти
          </button>


          <div class="trigger-container">
            <app-get-app-faq [className]="'get-app-faq-trigger'">Как это работает? (FAQ)</app-get-app-faq>
            <button type="button" nz-button nzType="default" class="get-app-faq-trigger">
              Меры безопасности
            </button>
          </div>
          <div id="ak_applet_place">&nbsp;</div>
          <div id="ak_applet_loading" style="display:none; position: fixed;top: 0;  left: 0;  width: 100%;  height: 100%;  z-index: 20000;  background-color: rgba(0,0,0,0.5); text-align:center; "></div>

        </div>
        </nz-tab>
      </nz-tabset>

      <div *ngIf="!isAkKamalAvailable">
        <form nz-form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
          <h4 [translate]="'HOME.LOGIN_PAGE.LOGIN_BY_PHONE'">Вход в BCC Business</h4>
          <nz-form-item class="login-form__name" *ngIf="step === 0">
            <nz-form-label nzSpan="24" nzFor="phoneNumber" [innerHTML]="'HOME.LOGIN_PAGE.FORM.INPUT_PHONE' | translate">
              Номер телефона
            </nz-form-label>
            <nz-form-control [nzErrorTip]="'HOME.LOGIN_PAGE.FORM.ERROR_PHONE_REQUIRED' | translate">
              <input class="form-input" formControlName="phoneNumber" prefix="+7" mask=" (000) 000-00-00" nz-input
                id="phoneNumber" placeholder="+7 (700) 000-00-00" autocomplete="off" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="login-form__password" *ngIf="step === 1">
            <nz-form-label nzSpan="24" nzFor="userPass" [innerHTML]="'HOME.LOGIN_PAGE.FORM.INPUT_PASSWORD' | translate">
              Пароль
            </nz-form-label>
            <nz-form-control class="form-input" [nzErrorTip]="'HOME.LOGIN_PAGE.FORM.ERROR_PASSWORD_REQUIRED' | translate">
              <nz-input-group [nzSuffix]="visibilityTemplate">
                <input formControlName="password" [attr.name]="'userPass' + step" [attr.id]="'userPass' + step" type="text"
                  [ngClass]="passwordVisible ? 'password-visible' : 'password-hidden'" nz-input />
              </nz-input-group>
              <ng-template #visibilityTemplate>
                <img *ngIf="passwordVisible; else passwordHidden" src="assets/icons/Eye%20open/M.svg" alt=""
                  (click)="isPasswordVisible()">
                <ng-template #passwordHidden>
                  <img src="assets/icons/Eye%20close/M.svg" alt="" (click)="isPasswordVisible()">
                </ng-template>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <p class="text-red" *ngIf="loginForm.hasError('invalid_credentials')"
            [translate]="'HOME.LOGIN_PAGE.FORM.ERROR_INVALID_CREDENTIALS'">
            Неправильный номер телефона или пароль
          </p>
          <div>
            <button *ngIf="step === 0" (click)="checkValidLogin($event)" class="login-form__login-btn" nz-button
              nzType="primary" nzSize="large" [disabled]="!checkValidNumber()" type="submit">
              {{'HOME.LOGIN_PAGE.FORM.BTN_CONTINUE' | translate}}
            </button>
          </div>
          <div>
            <button *ngIf="step === 1" [nzLoading]="isLoading" class="login-form__login-btn" nz-button nzType="primary"
              nzSize="large" [disabled]="!checkFormValid()" type="submit">
              {{'HOME.LOGIN_PAGE.FORM.BTN_LOGIN' | translate}}
            </button>
          </div>
          <app-faq *ngIf="step === 0"></app-faq>
          <app-safety-measures *ngIf="step === 0"></app-safety-measures>
          <p (click)="goToRecovery()" *ngIf="step === 1" class="login-form__forgot-password"
            [translate]="'HOME.LOGIN_PAGE.FORM.FORGOT_PASSWORD'">Не
            помните
            пароль?</p>
        </form>
        <!-- Шаг 2, выбор компании-->
        <div class="stepBlock" *ngIf="step === 2">
          <nz-form-item class="companySelector">
            <nz-form-label nzSpan="24">
              <h4 [translate]="'HOME.LOGIN_PAGE.FORM.SELECT_COMPANY'">Выберите компанию</h4>
            </nz-form-label>
            <nz-form-control>
              <nz-select [(ngModel)]="selectedCompany">
                <nz-option *ngFor="let company of companyList" [nzLabel]="company.custname" [nzValue]="company.pcustomer">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <button [disabled]="!selectedCompany || companyList?.length === 1" class="login-form__login-btn" nz-button
            nzType="primary" nzSize="large" (click)="selectCompany()" [nzLoading]="isLoading"
            [translate]="'HOME.LOGIN_PAGE.FORM.SELECT'" type="submit">
            Выбрать
          </button>
        </div>
        <!--Шаг 3, если нужна 2фа-->
        <div class="stepBlock " *ngIf="step === 3">
          <nz-form-item class="companySelector">
            <nz-form-label nzSpan="24">
              Введите код СМС
            </nz-form-label>
            <nz-form-control>
              <input nz-input [(ngModel)]="sms" (keydown.enter)="loginWith2fa()" maxlength="5" />
            </nz-form-control>
          </nz-form-item>
          <button nz-button nzType="link" class="pt-0" (click)="selectCompany()" [disabled]="smsTimer > 0"
            [nzLoading]="isLoading">Отправить код повторно <span *ngIf="smsTimer > 0">, через
              {{this.smsTimer}}</span></button>
          <button [disabled]="!sms" class="login-form__login-btn" nz-button nzType="primary" nzSize="large"
            (click)="loginWith2fa()" [nzLoading]="isLoading" type="submit">
            Подтвердить
          </button>
        </div>
      </div>

    </div>
  </section>
  <div nz-col [nzMd]="24" [nzLg]="2"><span class="splitter"></span></div>
  <section class="w100 qrMobile" nz-col [nzMd]="24" [nzLg]="11">
    <app-qr-login></app-qr-login>
  </section>
</main>
